/* Almla redesign: product cards (snippets/alm-card.liquid). Registers every
   card with the cart drawer (for upsells), sends the + button through
   AlmCart, and swaps a card to another style when a variant bubble is tapped,
   the way the Shop All grid does. Card data comes from data-alm. Also draws
   cards from saved data (Recently viewed) with AlmCards.html().
   The + opens Quick Look, the same drawer as the Shop All grid (client
   feedback, Oct 12: Quick Look on every listing, with every product photo).
   AlmCards.pics() fills a drawer's photo row from the product's own data, and
   the Shop All drawer (assets/alm-collection.js) uses it too. */
(function () {
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  };
  function data(el) {
    try { return JSON.parse(el.getAttribute("data-alm")); } catch (e) { return null; }
  }
  function scan() {
    if (!window.AlmCart) return;
    var seen = {};
    AlmCart.register([].map.call(document.querySelectorAll(".cardwrap[data-alm], .vd[data-alm], .pcard[data-alm], .pc[data-alm]"), data).filter(function (x) {
      if (!x || seen[x.h]) return false;
      seen[x.h] = 1;
      return true;
    }));
  }

  /* One tag per card (client, Oct 13): New, then Back in Stock, then Best
     Seller for the top of the list only (bt, snippets/alm-best-top.liquid).
     Sold Out is a state and shows as well. */
  function tag(x) { return x.n ? "New" : x.bk && !x.s ? "Back in Stock" : x.bt ? "Best Seller" : ""; }
  function flags(x) {
    var t = tag(x), f = t ? '<span class="flag' + (x.n ? " is-new" : "") + '">' + t + "</span>" : "";
    if (x.s) f += '<span class="flag is-out">Sold Out</span>';
    return '<span class="flags">' + f + "</span>";
  }
  function action(x) {
    return x.s
      ? '<span class="notify">Notify Me When Back</span>'
      : '<span class="plus" role="button" tabindex="0" data-qadd aria-haspopup="dialog" aria-label="Quick look: ' + esc(x.t) + '"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg></span>';
  }
  /* The card's photo slider, as snippets/alm-card.liquid prints it. Saved or
     swapped card data carries two photos; the rest arrive on first hover or
     touch from /products/<handle>.js (data-cs-fetch). */
  function slider(x) {
    var two = x.i && x.i2;
    return '<figure data-cs style="--cs-n:' + (two ? 2 : 1) + '"' + (two ? ' data-cs-fetch="' + esc(x.h) + '"' : "") + '><div class="cs">' +
      (x.i ? '<img class="ci ci1" loading="lazy" src="' + esc(x.i) + '" alt="' + esc(x.t) + '">' : "") +
      (two ? '<img class="ci cs-s" loading="lazy" src="' + esc(x.i2) + '" alt="">' : "") + "</div>" +
      (two ? '<img class="ci ci2" loading="lazy" src="' + esc(x.i2) + '" alt="" aria-hidden="true">' + ARROWS : "");
  }
  var ARROWS = '<span class="cs-arw cs-prev" role="button" tabindex="-1" data-cs-go="-1" aria-label="Previous photo"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3L5 8l5 5"/></svg></span>' +
    '<span class="cs-arw cs-next" role="button" tabindex="-1" data-cs-go="1" aria-label="Next photo"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3l5 5-5 5"/></svg></span>' +
    '<span class="cs-bar" aria-hidden="true"><i></i></span>';
  function inner(x) {
    return slider(x) +
      flags(x) + action(x) + "</figure>" +
      "<h3>" + esc(x.t) + '</h3><p class="price">' + esc(x.f) + "</p>";
  }
  /* A whole card from saved data, without bubbles (Recently viewed). */
  function html(x) {
    return '<div class="cardwrap" data-alm="' + esc(JSON.stringify(x)) + '"><a class="card' + (x.s ? " is-out" : "") + '" href="' + esc(x.u) + '">' +
      inner(x) + '</a><div class="vdots vdots-empty"></div></div>';
  }

  /* Every photo of a product, from /products/<handle>.js (cached). */
  var PICS = {};
  function photos(h) {
    if (!PICS[h]) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      PICS[h] = fetch(root + "products/" + encodeURIComponent(h) + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : { images: [] }; })
        .then(function (d) {
          return (d.images || []).map(function (u) { return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=900"; });
        })
        .catch(function () { delete PICS[h]; return []; });
    }
    return PICS[h];
  }
  /* Fill a drawer's photo row with all of a product's photos, unless the
     drawer has moved on to another product by the time they arrive. */
  function pics(row, h, alt) {
    if (!row || !h) return;
    photos(h).then(function (list) {
      if (!row.isConnected || list.length < 2) return;
      row.innerHTML = list.map(function (src, k) {
        return '<img src="' + esc(src) + '" alt="' + (k ? "" : esc(alt)) + '"' + (k > 1 ? ' loading="lazy"' : "") + ">";
      }).join("");
      row.scrollLeft = 0;
    });
  }

  /* Quick Look drawer, built on first use. */
  var QL, QLS, cur = null, lastFocus = null;
  function qlBuild() {
    if (QL) return;
    QLS = document.createElement("div");
    QLS.className = "ql-scrim";
    QLS.hidden = true;
    QLS.setAttribute("data-cql-close", "");
    QL = document.createElement("aside");
    QL.className = "ql";
    QL.setAttribute("role", "dialog");
    QL.setAttribute("aria-modal", "true");
    QL.setAttribute("aria-label", "Quick look");
    QL.setAttribute("aria-hidden", "true");
    QL.innerHTML = '<div class="ql-in" data-cql-body></div>';
    document.body.appendChild(QLS);
    document.body.appendChild(QL);
  }
  function sibs(w) {
    return w ? [].map.call(w.querySelectorAll(".vd[data-alm]"), data).filter(Boolean) : [];
  }

  /* Quick Look's styles and upsells come from the whole of Shop All (client
     feedback, Oct 13: a card only carries five bubbles, so the Goldendoodle
     hat's Quick Look showed no hats). Loaded once, on the first + hover or tap,
     from the same data the Shop All grid uses (templates/collection.alm-data.liquid).
     The styles are every product of the card's group collection (gh), in-stock
     first, in Shop All order, as the Shop All drawer lists them. */
  var ALL = null, ALLP = null;
  function loadAll() {
    if (ALLP) return ALLP;
    var base = ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "collections/shop-all?view=alm-data";
    function get(n) { return fetch(base + (n > 1 ? "&page=" + n : ""), { credentials: "same-origin" }).then(function (r) { if (!r.ok) throw r; return r.json(); }); }
    ALLP = get(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(get(n));
      return Promise.all(rest).then(function (more) {
        ALL = more.reduce(function (all, d) { return all.concat(d.products); }, first.products);
        return ALL;
      });
    }).catch(function () { ALLP = null; return null; });
    return ALLP;
  }
  // Category as the Shop All strip has it: Hats / Totes tiles, then Bundles, else Socks.
  function catOf(H) { return H.indexOf("hats") > -1 ? "Hats" : H.indexOf("totes") > -1 ? "Totes" : H.indexOf("bundles") > -1 ? "Bundles" : "Socks"; }
  // A hat or tote belongs to its category's group, not to a theme's (Pets),
  // as on Shop All and in snippets/alm-card.liquid.
  function inGroup(o, gh) { return o.H.indexOf(gh) > -1 && (gh === "hats" || gh === "totes" || (o.cat !== "Hats" && o.cat !== "Totes")); }
  function fromRow(r, x) {
    var H = r.h || [], c = Math.round(r.p * 100), v = c / 100;
    var num = v.toLocaleString("en-US", { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
    var o = { h: (r.u || "").split("/products/")[1] || "", v: r.v, t: r.t, u: r.u, p: c,
      // Same currency look as the card the drawer opened from.
      f: x.f && /\d/.test(x.f) ? x.f.replace(/\d[\d.,]*/, num) : "$" + num,
      i: r.i, i2: r.i2, s: !!r.s, b: H.indexOf("best-sellers") > -1, n: H.indexOf("new-arrivals-1") > -1,
      x: H.indexOf("bundles") > -1, bt: !!r.bt, bk: H.indexOf("back-in-stock") > -1, gc: !!r.gc, H: H, cat: catOf(H) };
    // Group fields only for the opened style's group, so an upsell from
    // another group keeps its own in the cart drawer.
    if (inGroup(o, x.gh)) { o.g = x.g; o.gh = x.gh; }
    return o;
  }
  function full(x) {
    if (!ALL || !x.gh) return null;
    var rows = ALL.map(function (r) { return fromRow(r, x); }).filter(function (o) { return !o.gc; });
    var me = rows.filter(function (o) { return o.h === x.h; })[0];
    if (!me) return null;
    var vars = rows.filter(function (o) { return inGroup(o, x.gh); });
    vars = vars.filter(function (o) { return !o.s; }).concat(vars.filter(function (o) { return o.s; }));
    vars = vars.map(function (o) { return o.h === x.h ? Object.assign({}, x, { cat: me.cat }) : o; });
    // You may also like: the same group and category first (hats for a hat),
    // then the same category, the rest of the group, then the Best Seller tags.
    var here = (window.ALM_PDP || {}).handle, ups = [];
    [function (o) { return inGroup(o, x.gh) && o.cat === me.cat; }, function (o) { return o.cat === me.cat; },
     function (o) { return inGroup(o, x.gh); }, function (o) { return o.bt; }].forEach(function (f) {
      rows.forEach(function (o) { if (ups.length < 4 && o.h !== x.h && o.h !== here && !o.s && ups.indexOf(o) === -1 && f(o)) ups.push(o); });
    });
    return { vars: vars, ups: ups };
  }

  function qlRender(x, vars, ups) {
    cur = { x: x, vars: vars };
    if (window.AlmCart) AlmCart.register([x].concat(vars, ups || []));
    // Never the product whose page this is (the PDP rows open Quick Look too).
    var here = (window.ALM_PDP || {}).handle;
    ups = ups || vars.filter(function (o) { return o.h !== x.h && o.h !== here && !o.s; }).slice(0, 4);
    if (ups.length < 4) {
      var seen = {};
      seen[x.h] = 1;
      if (here) seen[here] = 1;
      ups.forEach(function (o) { seen[o.h] = 1; });
      [].forEach.call(document.querySelectorAll(".cardwrap[data-alm]"), function (w) {
        var o = data(w);
        if (ups.length < 4 && o && !o.s && !seen[o.h]) { seen[o.h] = 1; ups.push(o); }
      });
    }
    var flag = tag(x) ? '<span class="flag">' + tag(x) + "</span>" : "";
    var body = QL.querySelector("[data-cql-body]");
    body.innerHTML =
      '<button type="button" class="ql-x" data-cql-close aria-label="Close quick look">&times;</button>' +
      '<div class="ql-pics">' + [x.i, x.i2].filter(Boolean).map(function (src, k) { return '<img src="' + esc(src) + '" alt="' + (k ? "" : esc(x.t)) + '">'; }).join("") + "</div>" +
      '<div class="ql-info">' + flag +
      "<h2>" + esc(x.t) + '</h2><p class="ql-price">' + esc(x.f) + "</p>" +
      (vars.length > 1 ? '<p class="ql-lbl">More from ' + esc(x.g) + '</p><div class="ql-vars">' + vars.map(function (o, k) {
        return '<button type="button" class="vd' + (o.h === x.h ? " is-on" : "") + (o.s ? " is-out" : "") + '" data-cqlswap="' + k + '" aria-pressed="' + (o.h === x.h) + '" aria-label="' + esc(o.t) + (o.s ? ", sold out" : "") + '" title="' + esc(o.t) + '" style="background-image:url(' + esc(o.i) + ')"></button>';
      }).join("") + "</div>" : "") +
      (x.s
        ? '<div class="ql-buy"><a class="ql-add is-notify" href="' + esc(x.u) + '">Notify Me When Back</a></div>'
        : '<div class="ql-buy"><div class="qty" aria-label="Quantity"><button type="button" data-cqty="-1" aria-label="Fewer">&minus;</button><span data-cqty-n>1</span><button type="button" data-cqty="1" aria-label="More">+</button></div>' +
          '<button type="button" class="ql-add" data-cqladd>Add to Cart</button></div>') +
      '<a class="ql-full" href="' + esc(x.u) + '">View full details</a>' +
      (ups.length ? '<div class="ql-ups"><p class="ql-lbl">You may also like</p><div class="ql-uprow">' + ups.map(function (o, k) {
        // Same round + as the product cards (client feedback, Oct 13).
        return '<div class="ql-up"><div class="ql-upfig"><a href="' + esc(o.u) + '"><img src="' + esc(o.i) + '" alt="' + esc(o.t) + '" loading="lazy"></a><button type="button" class="ql-upadd" data-cupadd="' + k + '" aria-label="Add ' + esc(o.t) + ' to cart"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg></button></div><b>' + esc(o.t) + "</b><span>" + esc(o.f) + "</span></div>";
      }).join("") + "</div></div>" : "") + "</div>";
    cur.ups = ups;
    pics(body.querySelector(".ql-pics"), x.h, x.t);
  }
  // The whole group when Shop All's data is in, else the card's own bubbles
  // until it arrives.
  function qlShow(x, fallback) {
    var F = full(x);
    if (F) qlRender(x, F.vars, F.ups);
    else qlRender(x, fallback);
  }
  function qlOpen(btn) {
    var w = btn.closest(".cardwrap"), x = w && data(w);
    if (!x) return;
    qlBuild();
    lastFocus = document.activeElement;
    var fb = sibs(w);
    qlShow(x, fb);
    if (!ALL) loadAll().then(function () {
      if (QL.classList.contains("is-open") && cur && cur.x.h === x.h) {
        var n = QL.querySelector("[data-cqty-n]"), q = n ? n.textContent : "1";
        qlShow(x, fb);
        n = QL.querySelector("[data-cqty-n]"); if (n) n.textContent = q;
      }
    });
    QL.classList.add("is-open");
    QL.setAttribute("aria-hidden", "false");
    QLS.hidden = false;
    document.documentElement.classList.add("ql-lock");
    var c = QL.querySelector(".ql-x");
    if (c) c.focus();
  }
  function qlClose() {
    if (!QL || !QL.classList.contains("is-open")) return;
    QL.classList.remove("is-open");
    QL.setAttribute("aria-hidden", "true");
    QLS.hidden = true;
    document.documentElement.classList.remove("ql-lock");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function qlClick(e) {
    if (e.target.closest("[data-cql-close]")) { qlClose(); return true; }
    if (!QL || !QL.contains(e.target) || !cur) return false;
    var sw = e.target.closest("[data-cqlswap]");
    if (sw) { var nx = cur.vars[+sw.getAttribute("data-cqlswap")]; if (nx) qlShow(nx, cur.vars); return true; }
    var qb = e.target.closest("[data-cqty]");
    if (qb) {
      var n = QL.querySelector("[data-cqty-n]");
      n.textContent = Math.max(1, +n.textContent + +qb.getAttribute("data-cqty"));
      return true;
    }
    var add = e.target.closest("[data-cqladd]");
    if (add && window.AlmCart) {
      var qn = QL.querySelector("[data-cqty-n]"), h = cur.x.h;
      AlmCart.register([cur.x]);
      qlClose();
      AlmCart.add(h, qn ? +qn.textContent : 1);
      return true;
    }
    var up = e.target.closest("[data-cupadd]");
    if (up && window.AlmCart) {
      var o = cur.ups[+up.getAttribute("data-cupadd")];
      if (!o) return true;
      up.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4.5 10.5l3.5 3.5 7.5-8"/></svg>';
      up.setAttribute("aria-label", "Added " + o.t + " to cart");
      up.classList.add("is-done");
      AlmCart.register([o]);
      // Upsells stay inside the quick look: they join the bag without opening the drawer.
      AlmCart.add(o.h, 1, true);
      return true;
    }
    return false;
  }
  function swap(b) {
    var w = b.closest(".cardwrap"), x = data(b);
    if (!w || !x) return;
    w.setAttribute("data-alm", b.getAttribute("data-alm"));
    var a = w.querySelector(".card");
    a.href = x.u;
    a.classList.toggle("is-out", !!x.s);
    a.innerHTML = inner(x);
    [].forEach.call(w.querySelectorAll(".vd"), function (o) {
      o.classList.toggle("is-on", o === b);
      o.setAttribute("aria-pressed", o === b);
    });
    if (window.AlmCart) AlmCart.register([x]);
  }

  /* Card photo slider (client feedback, Oct 13, after us.peppermayo.com): swipe
     on touch (native scroll-snap), small arrows on hover, a thin progress bar.
     On hover the second photo still fades in over the first; that counts as
     photo 2, so the next arrow goes on to photo 3. Photos past the second load
     on first hover / touch / focus. Works for every card: Liquid
     (snippets/alm-card.liquid), Shop All (assets/alm-collection.js) and saved
     cards (html() above). */
  function csIndex(fig) {
    var t = fig.querySelector(".cs");
    return t && t.clientWidth ? Math.round(t.scrollLeft / t.clientWidth) : 0;
  }
  function csCount(fig) { return fig.querySelectorAll(".cs > .ci").length; }
  function csPaint(fig) {
    var n = csCount(fig), i = csIndex(fig);
    // The hover crossfade shows photo 2 while the track is still on photo 1.
    if (i === 0 && fig.classList.contains("cs-hover") && !fig.classList.contains("cs-moved") && n > 1) i = 1;
    fig.style.setProperty("--cs-n", n);
    fig.style.setProperty("--cs-i", i);
    fig.classList.toggle("cs-first", i === 0);
    fig.classList.toggle("cs-last", i >= n - 1);
  }
  function csWake(fig) {
    if (!fig || fig.getAttribute("data-cs-awake")) return;
    fig.setAttribute("data-cs-awake", "1");
    [].forEach.call(fig.querySelectorAll(".cs img[data-src]"), function (im) {
      im.src = im.getAttribute("data-src");
      im.removeAttribute("data-src");
    });
    var h = fig.getAttribute("data-cs-fetch");
    if (h) photos(h).then(function (list) {
      var t = fig.querySelector(".cs");
      if (!t || !t.isConnected || list.length < 3) return;
      t.insertAdjacentHTML("beforeend", list.slice(2, 8).map(function (src) {
        return '<img class="ci cs-s" src="' + esc(src.replace("width=900", "width=600")) + '" alt="">';
      }).join(""));
      csPaint(fig);
    });
    csPaint(fig);
  }
  function csGo(fig, dir) {
    var t = fig.querySelector(".cs"), n = csCount(fig);
    if (!t || n < 2) return;
    var i = csIndex(fig);
    if (i === 0 && fig.classList.contains("cs-hover") && !fig.classList.contains("cs-moved")) i = 1;
    var to = Math.max(0, Math.min(n - 1, i + dir));
    fig.classList.add("cs-moved");
    t.scrollTo({ left: to * t.clientWidth, behavior: "smooth" });
    fig.style.setProperty("--cs-i", to);
    fig.classList.toggle("cs-first", to === 0);
    fig.classList.toggle("cs-last", to >= n - 1);
  }
  /* Cards inside a sideways rail (homepage lanes, product page rails): on
     touch the swipe belongs to the rail, so the card's photos do not swipe
     there (alm-card.css, .cs-rail); arrows still work with a mouse. */
  function csRails() {
    [].forEach.call(document.querySelectorAll("[data-cs]:not([data-cs-rail-checked])"), function (fig) {
      fig.setAttribute("data-cs-rail-checked", "");
      for (var p = fig.parentElement; p && p !== document.body; p = p.parentElement) {
        var o = getComputedStyle(p).overflowX;
        if (o === "auto" || o === "scroll") { fig.classList.add("cs-rail"); break; }
      }
    });
  }
  var csRaf = 0;
  document.addEventListener("scroll", function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains("cs")) return;
    var fig = t.closest("[data-cs]");
    csWake(fig);
    if (t.scrollLeft > 4) fig.classList.add("cs-moved");
    cancelAnimationFrame(csRaf);
    csRaf = requestAnimationFrame(function () { csPaint(fig); });
  }, true);
  document.addEventListener("touchstart", function (e) {
    if (e.target.closest && e.target.closest(".cardwrap [data-qadd]")) loadAll();
    var fig = e.target.closest && e.target.closest("[data-cs]");
    if (fig && !fig.hasAttribute("data-cs-rail-checked")) csRails();
    if (fig && !fig.classList.contains("cs-rail")) csWake(fig);
  }, { passive: true, capture: true });
  document.addEventListener("pointerover", function (e) {
    if (e.target.closest && e.target.closest(".cardwrap [data-qadd]")) loadAll();
    if (e.pointerType !== "mouse") return;
    var fig = e.target.closest && e.target.closest("[data-cs]");
    if (!fig || fig.classList.contains("cs-hover")) return;
    fig.classList.add("cs-hover");
    csWake(fig);
    csPaint(fig);
  });
  document.addEventListener("pointerout", function (e) {
    var fig = e.target.closest && e.target.closest("[data-cs]");
    if (!fig || (e.relatedTarget && fig.contains(e.relatedTarget))) return;
    fig.classList.remove("cs-hover");
    if (csIndex(fig) === 0) fig.classList.remove("cs-moved");
    csPaint(fig);
  });
  document.addEventListener("focusin", function (e) {
    var fig = e.target.closest && e.target.closest(".card") && e.target.closest(".card").querySelector("[data-cs]");
    if (fig) csWake(fig);
  });

  document.addEventListener("click", function (e) {
    var go = e.target.closest && e.target.closest("[data-cs-go]");
    if (go) {
      e.preventDefault();
      e.stopPropagation();
      csGo(go.closest("[data-cs]"), +go.getAttribute("data-cs-go"));
      return;
    }
    if (qlClick(e)) return;
    var plus = e.target.closest(".cardwrap [data-qadd]");
    if (plus) { e.preventDefault(); qlOpen(plus); return; }
    var vd = e.target.closest(".cardwrap .vd[data-alm]");
    if (vd) { e.preventDefault(); swap(vd); return; }
    var b = e.target.closest(".pcard .atc");
    if (!b || b.disabled || !window.AlmCart) return;
    e.preventDefault();
    var x = data(b.closest(".pcard"));
    if (!x) return;
    AlmCart.register([x]);
    AlmCart.add(x.h, 1);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") qlClose();
    if ((e.key === "Enter" || e.key === " ") && e.target.matches && e.target.matches(".cardwrap [data-qadd]")) {
      e.preventDefault();
      qlOpen(e.target);
    }
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { scan(); csRails(); });
  else { scan(); csRails(); }
  window.AlmCards = { scan: scan, html: html, pics: pics };
})();
